import { createFileRoute } from '@tanstack/react-router';

import { ProcessesCatalogPage } from '../../pages/catalog/processes/ProcessesCatalogPage';

export const Route = createFileRoute('/_auth/catalog/processes/')({
  component: ProcessesCatalogPage,
});
